import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import striptags from 'striptags';
import { get as getCookie } from 'js-cookie';
import { addItem } from 'ducks/cart';
import { toggleAddToCart } from 'ducks/ui';
import { ProductType } from 'types';
import { AddToCart, Container, SeoTags } from 'components/shared';
import { theme, media } from 'styles';
import guestCartCookieName from 'helpers/guestCartCookieName';
import { Header } from './components';

const { sp, colors } = theme;

const CartBar = styled.div`
  top: 60px;
  left: 0;
  right: 0;
  z-index: 999;
  ${media.ldesktop`
    top: 80px;
  `};
`;

const Wrapper = styled.div`
  background: ${colors.white};
  padding-bottom: 100px;
  font-size: 18px;

  .sticky {
    position: relative;
    z-index: 10000;
  }
`;

const Main = styled(Container)`
  display: flex;
  flex-direction: column;
  margin-top: 80px;

  ${media.tablet`
    flex-direction: row;
  `};
`;

const MainWrapper = styled.div`
  flex: 1;

  p,
  ul,
  ol {
    counter-reset: item;
    line-height: 1.4;
    font-weight: 400;
    margin-bottom: ${sp.l};

    ${media.tablet`
      margin-bottom: ${sp.xl};
    `};
  }

  ol,
  ul {
    padding: 0;
  }

  ul li {
    position: relative;
    list-style: none;
    padding-left: 40px;
    margin-bottom: ${sp.s};

    &::before {
      position: absolute;
      top: 15px;
      left: 0;
      width: 20px;
      height: 2px;
      background-color: ${colors.blue};
      content: '';
    }
  }

  ol li {
    position: relative;
    counter-increment: item;
    list-style: none;
    padding-left: 40px;
    margin-bottom: ${sp.s};

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: counters(item, '') '.';
      color: ${colors.blue};
      width: 20px;
    }
  }

  .fixed-bar {
    position: fixed;
  }
`;

const DescriptionWrapper = styled.div``;

const Description = styled.div`
  width: 80%;
`;

const MainTitle = styled.div`
  margin-bottom: ${sp.l};
  color: ${colors.grey};
  font-size: 16px;
`;

const AddToCartWrapper = styled.div`
  width: 100%;
  background: ${colors.navy};
`;

class ProductPage extends React.Component {
  static propTypes = {
    product: ProductType.isRequired,
    onAddItem: PropTypes.func.isRequired,
    onToggleAddToCart: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {};

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    this.props.onToggleAddToCart();
  }

  componentDidMount() {
    /* eslint-disable react/no-did-mount-set-state */
    const cb = document.getElementById('cartbar');
    if (cb !== null) {
      this.setState({ top: cb.offsetTop, height: cb.offsetHeight });
      this.setState({ scrollNeeded: media.ldesktop ? 80 : 60 });
    }
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate() {
    /* eslint no-unused-expressions: [2, { allowShortCircuit: true, allowTernary: true }] */
    this.state.scroll > this.state.top
      ? (document.body.style.paddingTop = `${this.state.height}px`)
      : (document.body.style.paddingTop = 0);
  }

  componentWillUnmount() {
    this.props.onToggleAddToCart();
  }

  handleScroll() {
    this.setState({ scroll: window.scrollY + this.state.scrollNeeded });
  }

  addToCart = async (quantity, months, recurring) => {
    const cartId = getCookie(guestCartCookieName);
    this.props.onAddItem(cartId, {
      sellableId: this.props.product.id,
      sellableType: 'Product',
      quantity,
      months,
      recurring,
    });
  };

  render() {
    const { product } = this.props;
    const { seoTitle, seoKeywords, seoDescription } = product;

    return (
      <Wrapper>
        <SeoTags
          title={seoTitle}
          keywords={seoKeywords}
          description={seoDescription}
        />

        <Header product={product} />

        <CartBar
          id="cartbar"
          style={{
            position: this.state.scroll > this.state.top ? 'fixed' : 'initial',
          }}
        >
          <AddToCartWrapper>
            <AddToCart product={product} onAddToCart={this.addToCart} />
          </AddToCartWrapper>
        </CartBar>
        <Main>
          <MainWrapper>
            <DescriptionWrapper>
              <MainTitle>Description</MainTitle>
              <Description
                dangerouslySetInnerHTML={{ __html: product.description }}
              />
            </DescriptionWrapper>
          </MainWrapper>
          {!isEmpty(striptags(product.benefitsAndDeliverables)) && (
            <MainWrapper>
              <DescriptionWrapper>
                <MainTitle>Benefits / Deliverables</MainTitle>
                <Description
                  dangerouslySetInnerHTML={{
                    __html: product.benefitsAndDeliverables,
                  }}
                />
              </DescriptionWrapper>
            </MainWrapper>
          )}
        </Main>
      </Wrapper>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  onAddItem: addItem,
  onToggleAddToCart: toggleAddToCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);



// WEBPACK FOOTER //
// ./src/components/ProductPage/ProductPage.jsx